import React, { useEffect, useState } from "react";

const HINT_SHOWN_KEY = "assistant_hint_shown";

// The Albi Assistant (Perceptron, loaded in public/index.html) renders its launcher inside an open shadow root.
const findAssistantButton = () => {
    for (const host of document.body.children) {
        const button = host.shadowRoot?.querySelector('button[class*="_bubble_"]');
        if (button) return button;
    }
    return null;
};

export default function AssistantHint() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        try {
            if (sessionStorage.getItem(HINT_SHOWN_KEY) === "1") return;
        } catch {}
        let timer;
        let attempts = 0;
        const tryShow = () => {
            if (!findAssistantButton()) {
                // The assistant script can still be loading; keep checking for a few seconds.
                if (++attempts < 16) timer = window.setTimeout(tryShow, 500);
                return;
            }
            setVisible(true);
            // Shown only once per visit: navigating away or refreshing must not bring it back.
            try {
                sessionStorage.setItem(HINT_SHOWN_KEY, "1");
            } catch {}
        };
        timer = window.setTimeout(tryShow, 2000);
        return () => window.clearTimeout(timer);
    }, []);

    useEffect(() => {
        if (!visible) return;
        // On mobile the centered "Kthehu lart" button (BackToTop, shown past 400px) sits where this hint is.
        const onScroll = () => {
            if (window.innerWidth < 768 && window.scrollY > 400) setVisible(false);
        };
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, [visible]);

    const hide = () => setVisible(false);

    const openAssistant = () => {
        findAssistantButton()?.click();
        hide();
    };

    if (!visible) return null;

    return (
        <div className="fixed bottom-[calc(60px+env(safe-area-inset-bottom,0px))] right-[90px] md:bottom-9 md:right-[92px] z-50 flex items-center bg-white text-black border border-gray-200 rounded-full shadow-md text-xs">
            <button type="button" onClick={openAssistant} className="pl-3 pr-1 py-1.5 font-medium whitespace-nowrap">
                Si mund t'ju ndihmojmë?
            </button>
            <button
                type="button"
                onClick={hide}
                className="pr-2.5 pl-1 py-1.5 text-gray-400 hover:text-gray-700 leading-none"
                aria-label="Mbyll"
            >
                ×
            </button>
        </div>
    );
}
